export enum ResourceSubtype {
  Audio = 'audio',
  Video = 'video',
  ThreeDimensional = '3D',
}
